<template>
    <span v-if="error" class="text-danger form-select-sm">
        {{ error }}
    </span>

</template>

<script>
export default {
    name: 'ErrorSpan',
    props: ['error']

};
</script>